// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-hovered{background-color:hsla(0,0%,43.9%,.12157)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
